import { z } from 'zod'
import { versionedRecordSchema } from './records.ts'

const text = z.string().trim().min(1).max(1000)
const optionalText = z.string().trim().max(1000).nullable()
const quantity = z
  .string()
  .regex(/^\d{1,24}(?:\.\d{1,3})?$/)
  .refine((value) => /[1-9]/.test(value))
const day = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .refine((value) => {
    const parsed = Date.parse(`${value}T12:00:00Z`)
    return Number.isFinite(parsed) && new Date(parsed).toISOString().slice(0, 10) === value
  })

export const shipmentCarrierSchema = z.enum(['nova_poshta', 'own', 'pickup', 'other'])
export const shipmentStatusSchema = z.enum(['planned', 'in_transit', 'at_branch', 'delivered'])
export const shipmentLineSchema = z.object({ lineId: text, quantity }).strict()
export const shipmentCargoSchema = z.object({ name: text, quantity, unit: text }).strict()

const shipmentFields = {
  carrier: shipmentCarrierSchema,
  carrierName: optionalText,
  recipient: z.object({ name: text, phone: optionalText, role: optionalText }).strict(),
  destination: z.object({ country: text, city: text, point: text }).strict(),
  ttn: optionalText,
  customsDeclaration: optionalText,
  vehicle: optionalText,
  places: z.number().int().positive().max(1_000_000).nullable(),
  weightKg: quantity.nullable(),
  plannedAt: day,
  send: z.boolean(),
}

export const shipmentCreateSchema = z
  .object({
    ...shipmentFields,
    dealId: text,
    orderVersion: z.number().int().positive(),
    lines: z.array(shipmentLineSchema).min(1).max(500),
  })
  .strict()
export const manualShipmentCreateSchema = z
  .object({ ...shipmentFields, cargo: z.array(shipmentCargoSchema).min(1).max(500) })
  .strict()
export const shipmentChangeSchema = versionedRecordSchema.strict()
export const shipmentTtnSchema = versionedRecordSchema.extend({ ttn: optionalText }).strict()
export const shipmentSendSchema = shipmentTtnSchema

export type ShipmentCreateInput = z.infer<typeof shipmentCreateSchema>
export type ManualShipmentCreateInput = z.infer<typeof manualShipmentCreateSchema>
export type ShipmentChangeInput = z.infer<typeof shipmentChangeSchema>
export type ShipmentTtnInput = z.infer<typeof shipmentTtnSchema>
export type ShipmentSendInput = z.infer<typeof shipmentSendSchema>
